import $ from "jquery";
import Wow from 'wow.js';
import { f } from "./components/_f";
import mediumZoom from "medium-zoom";
import Header from "./components/Header";
import CookieBanner from "./components/CookieBanner";

window.f    = f;
window.Main = window.Main || {
    MuseumApp: null,
    app:       null,

    init: function() {
        Main.initPlugins();
        Main.registerHooks();
    },

    initPlugins: function() {
        Main.Header = new Header();

        Main.CookieBanner = new CookieBanner();

        // AOS.init();
        new Wow().init();

        // mediumZoom('.wp-block-gallery a img', {
        //     margin:     20,
        //     background: 'rgba(255, 255, 255, .9)'
        // });

        $('body').on('click', '.wp-block-gallery a', function( e ) {
            e.preventDefault();
        });
    },

    registerHooks: function() {
        $('a[href*=\\#]').click(function( e ) {
            let $trigger          = $(this),
                targetAnchor      = $trigger.attr('href'),
                targetAnchorSplit = targetAnchor.split('#');

            // If it's just a blank anchor for testing or triggers
            if ( targetAnchor === '#' ) {
                e.preventDefault();
                return;
            }
                // Only trigger scrollTO when the hash is not in the middle of an Url
            // or (if it is) the URL before the hash is the same as the current Url
            else if ( targetAnchorSplit[0] != false
                && targetAnchorSplit[0] !== ( window.location.origin + window.location.pathname ) )
            {
                return;
            }

            e.preventDefault();
            Main.scrollTo('#' + targetAnchorSplit[1], () => { window.location.hash = targetAnchorSplit[1]; });
        });
    },

    scrollTo: function( anchor, callback = () => {}, duration = 1500 ) {
        $('html, body')
            .animate({
                scrollTop: $(anchor).offset().top
            }, duration, callback);

        $('body').trigger('app:scrollto', [anchor]);
    }
};

$(document).ready(function() {
    Main.init();
});
